<template>

    <div>
        <line-chart v-if="type ==='line'" :translations="translations" :data="data"></line-chart>
        <chart v-if="type !=='line'" legend="Legend" class="doughnut" ref="chart" :data="data" :type="type" :translations="translations" />
    </div>

</template>

<script>

    import LineChart from './LineChart'
    import Chart from './Chart'

    export default {

        components: {
            Chart,
            LineChart
        },

        props: {
            type : String,
            data : String,
            translations : String
        },

    }



</script>
